import popper from 'popper.js';
import tippy, {followCursor} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';
import 'tippy.js/themes/light.css';
import tooltipster from 'tooltipster';

  // tippy('button', {
  //   arrow: true,
  //   arrowType: 'sharp',
  //   animation: 'fade',
  //   content: '<div class="card">' + 
  //   '<h5 class="card-title">'+ 'asdfasdfsdfadf' +'</h5>' +
  //   '</div>',
    // content: '<div class="card"><img class="card-img-top" src="//image.tmdb.org/t/p/w500' + title['backdrop'] + 
    // '" onError="this.src = /images/no-backdrop-w500.png" alt="Card image cap"><div class="card-body">' + 
    // '<h5 class="card-title">'+ title['name'] +'</h5>' +
    //   '<p>' +
    //       '<a class="me-2 img-link" href="' + asset('images/netflix-symbol.png') + '" target="_blank">' +
    //           '<img class="grow" src="' + asset('images/netflix-symbol.png') +'" alt="Netflix" style="height:38px;">' +
    //       '</a>' +
    //       '<a class="me-2 img-link" href="' + asset('images/crave-icon.png') + '" target="_blank">' +
    //           '<img class="grow" src="' + asset('images/crave-icon.png') + '" alt="Crave" style="height:36px;">' +
    //       '</a>' +
    //       '<a class="me-2 img-link" href="' + asset('images/disney-plus-logo.png') + '" target="_blank">' +
    //           '<img class="grow" src="' + asset('images/disney-plus-logo.png') + '" alt="Disney Plus" style="height:36px;">' +
    //       '</a>' +
    //       '<a class="me-2 img-link" href="' + asset('images/amazon-prime-video-logo.png') + '" target="_blank">' +
    //           '<img class="grow" src="' + asset('images/amazon-prime-video-logo.png') + '" alt="Prime Video" style="height:20px;">' +
    //       '</a>' +
    //   '</p>' +
    // '</div>',
  //   allowHTML: true
  // });

  window.initializeStreamButtonTooltips = function() {
    tippy('a img[alt="Netflix"]', {
      content: "Watch on Netflix",
      animation: 'fade'
    });

    tippy('a img[alt="Crave"]', {
      content: "Watch on Crave",
      animation: 'fade'
    });

    tippy('a img[alt="Disney Plus"]', {
      content: "Watch on Disney+",
      animation: 'fade'
    });

    tippy('a img[alt="Prime Video"]', {
      content: "Watch on Prime Video",
      animation: 'fade'
    });

    tippy('.watchlist-btn', {
      content: "Add to Watchlist",
      animation: 'fade'
    });

    tippy('.more-info-btn', {
      animation: 'fade',
      content: "More info"
    });
  }

  window.initializeStreamTitleDetails = function (titles) {
    // console.log('initializeStreamTitleDetails');
    // console.log(titles);

    titles.forEach(function(title){
    // console.log(title);
    // console.log(title['name']);

    // console.log(title?.backdrop);
    // console.log(title?.backdrop?.file_path);

    // console.log("Netflix");
    // console.log(title?.id);
    // console.log(title['id']);
    // console.log(title['netflixLink']);
    // console.log(title['netflixLink'] ? true : false);

    // console.log("Crave");
    // console.log(title?.id);
    // console.log(title['id']);
    // console.log(title['craveLink']);
    // console.log(title['craveLink'] ? true : false);

    // var titleCard = document.getElementById('stream-card-title-' + title['id'] + '-type-' + title['type_id']);
    var titleCards = document.getElementsByClassName('stream-card-title-' + title['id'] + '-type-' + title['type_id']);
    var titleCardContentOld = '<div class="card h-100"><img class="card-img-top" src="//image.tmdb.org/t/p/w500' + title?.backdrop?.file_path + 
      '" onError="this.src = /images/no-backdrop-w500.png" alt="Card image cap"><div class="card-body">' + 
      '<h5 class="card-title">'+ title['name'] +'</h5>' +
        '<p>' + 
            '<a class="me-2 img-link" href="'+ netflixLogo +'" target="_blank">' +
                '<img class="grow" src="'+ netflixLogo +'" alt="Netflix" style="height:38px;">' +
            '</a>' +
            '<a class="me-2 img-link" href="'+ craveLogo +'" target="_blank">' +
                '<img class="grow" src="'+ craveLogo +'" alt="Crave" style="height:36px;">' +
            '</a>' +
            '<a class="me-2 img-link" href="'+ disneyPlusLogo +'" target="_blank">' +
                '<img class="grow" src="'+ disneyPlusLogo +'" alt="Disney Plus" style="height:36px;">' +
            '</a>' +
            '<a class="me-2 img-link" href="'+ amazonPrimeVideoLogo +'" target="_blank">' +
                '<img class="grow" src="'+ amazonPrimeVideoLogo +'" alt="Prime Video" style="height:20px;">' +
            '</a>' +
        '</p>' +
      '</div>';

    var titleCardContent = '<div class="">' +
        '<div class="btn-group">' + (title['netflixLink'] ?
            '<div class="btn"><a class="img-link" href="'+ title['netflixLink'] + '" target="_blank">' +
                '<img class="grow" src="'+ netflixLogo +'" alt="Netflix" style="height:38px;">' +
            '</a></div>' : '<span></span>') + (title['craveLink'] ?
            '<div class="btn"><a class="img-link" href="'+ title['craveLink'] + '" target="_blank">' +
                '<img class="grow" src="'+ craveLogo +'" alt="Crave" style="height:36px;">' +
            '</a></div>' : '<span></span>') + (title['disneyPlusLink'] ?
            '<div class="btn"><a class="img-link" href="'+ title['disneyPlusLink'] + '" target="_blank">' +
                '<img class="grow" src="'+ disneyPlusLogo +'" alt="Disney Plus" style="height:36px;">' +
            '</a></div>' : '<span></span>') + (title['amazonPrimeLink'] ?
            '<div class="btn"><a class="img-link" href="'+ title['amazonPrimeLink'] + '" target="_blank">' +
                '<img class="grow" src="'+ amazonPrimeVideoLogo +'" alt="Prime Video" style="height:20px;">' +
            '</a></div>' : '<span></span>') +
        '</div>' +
      '</div>';


      for (var i=0, max=titleCards.length; i < max; i++) {
        tippy(titleCards[i], {
          content: titleCardContent,
          theme: 'light',
          allowHTML: true,
          interactive: true,
          placement: 'top',
          animation: 'fade',
          delay: 500,
          // followCursor: 'initial',
          plugins: [followCursor],
          onShown(instance) {
            initializeStreamButtonTooltips();
          },
        });
      }

      // tippy(titleCard, {
      //   content: titleCardContent,
      //   theme: 'light',
      //   allowHTML: true,
      //   interactive: true,
      //   arrow: true,
      //   placement: 'top',
      //   animation: 'fade',
      //   delay: 500,
      //   // followCursor: 'initial',
      //   plugins: [followCursor],
      //   onShown(instance) {
      //     initializeStreamButtonTooltips();
      //   },
      // });

    });

  }


document.addEventListener('DOMContentLoaded', function() {

  window.initializeStreamTitleDetails(titles);
  window.initializeStreamButtonTooltips();

});